import apiClient from './client';

export interface Expense {
  id: string;
  description: string;
  amount: number;
  category?: string;
  date: string;
  branch: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateExpenseRequest {
  description: string;
  amount: number;
  category?: string;
  date: string;
}

export interface UpdateExpenseRequest {
  description?: string;
  amount?: number;
  category?: string;
  date?: string;
}

export const expensesApi = {
  getAll: async (): Promise<Expense[]> => {
    const response = await apiClient.get('/expenses');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<Expense> => {
    const response = await apiClient.get(`/expenses/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateExpenseRequest): Promise<Expense> => {
    const response = await apiClient.post('/expenses', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateExpenseRequest): Promise<Expense> => {
    const response = await apiClient.put(`/expenses/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/expenses/${id}`);
  },
};
